import React, { useContext } from 'react'
import { Card, CardActions, CardContent, CardMedia, IconButton, Typography, Grid, Icon } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { FavoriteBorder, FavoriteOutlined } from '@material-ui/icons'
import MyButton from '../custom_mui_components/MyButton'
import { ApiContext } from '../../context/ApiContext'
import { Container, Row, Col } from 'react-bootstrap'
import { ChevronRight } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
    cardRoot: {
        //boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.05)',
        boxShadow: 'none',
        position: 'relative',
        borderRadius: 0,
        borderWidth: 0,
        userSelect: 'none',
    },
    cardFavriteIcon: {
        position: 'absolute',
        right: '0px'
    },
    cardTitle: {
        //color: '#bf9410',
        color: 'white',
        textTransform: 'uppercase',
        textAlign: 'left',
        fontSize: '2.6rem',
        fontWeight: '600',
        [theme.breakpoints.down('xs')]: {
            fontSize: '2.0rem',
            fontWeight: '400'
        },
    },
    cardSubTitle: {
        color: 'white',
        fontSize: '1.2rem',
        fontWeight: '400',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8rem',
            fontWeight: '400'
        },
    },
    cardBody: {
        //color: '#bf9410',
        color: 'white',
        [theme.breakpoints.down('xs')]: {
            //fontSize: '0.7rem',
            //fontWeight: '400'
        },
    },
    arrow: {
        //color: '#bf9410',
        color: 'white',
        width: '30px',
        height: '25vh',
        //fontSize: '2.4rem',
        //fontWeight: '600',
        [theme.breakpoints.down('xs')]: {
            width: '20px',
            height: '12vh',
            //fontSize: '1.2rem',
            //fontWeight: '500'
        },
    },
    overlay: {
        position: 'absolute',
        left: '0px',
        top: '50%',
        //bottom: '10px',
        width: '100vw',
        //transform: 'translate(-50%, -50%)',
        //left: '20px',
        backgroundColor: 'transparent'
    },
    cardMedia: {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        width: '100vw',
    },
    cardText: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        flexDirection: 'column',
    }
}))
function Banner({ title, link, subTitle = "", body = "", background = "", height = 0.25 }) {
    const classes = useStyles()
    const history = useHistory()
    return (
        <Card className={classes.cardRoot}>
            <div onClick={link != null ? (e) => { history.push(link) } : null}>
                {false &&
                    <CardMedia className={classes.cardMedia} style={{ height: height }}>
                    <img className="w-100 h-100" src={background} alt={title} style={{ display: "block" }} />
                    </CardMedia>
                }
                <div className={classes.cardMedia} style={{ height: `calc(${100 * height}vh - ${90 * height}px)`, backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)), url(${background})` }}>
                    
                    <Container style={{ height: `calc(${100 * height}vh - ${90 * height}px)` }}>
                        <Row style={{ height: `calc(${100 * height}vh - ${90 * height}px)` }}>
                            <Col xs={10} sm={10} md={4} lg={4} xl={4} className={classes.cardText}>
                                <h1 className={classes.cardTitle}>
                                    {title}
                                </h1>
                                {subTitle != "" &&
                                    <Typography variant="body2" className={classes.cardSubTitle}>
                                        {subTitle}
                                    </Typography>
                                        }
                            </Col>
                            <Col xs={2} sm={2} md={1} lg={1} xl={1} className={classes.cardText}>
                                <ChevronRight preserveAspectRatio="none" className={classes.arrow} /> {/* style={{ height: `calc(${100 * height}vh - ${90 * height}px)` }}*/}
                            </Col>
                            <Col xs={12} sm={12} md={7} lg={7} xl={7} className={classes.cardText}>
                                {body != "" &&
                                    <Typography variant="subtitle1" className={classes.cardBody} dangerouslySetInnerHTML={{ __html: body }} />
                                }
                            </Col>
                        </Row>
                    </Container>
                    
                </div>
            </div>
        </Card>
    )
}

export default Banner